import { render, staticRenderFns } from "./mergecorpusDialog.vue?vue&type=template&id=056da919&scoped=true&"
import script from "./mergecorpusDialog.vue?vue&type=script&lang=js&"
export * from "./mergecorpusDialog.vue?vue&type=script&lang=js&"
import style0 from "./mergecorpusDialog.vue?vue&type=style&index=0&id=056da919&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056da919",
  null
  
)

export default component.exports